import { Grid } from '@material-ui/core';
import { useMemo } from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Redux
import { RootState } from 'src/store/rootReducer';
// Data Layer
import { defaultUnit } from 'data-layer-cr/dist/functions/quotations';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  Quotation,
} from 'data-layer-cr/dist/models';
// components
import {
  ContractingInformationCard,
  IndividualUnitResumeCard,
  VehicleInformationCard,
} from '../InformationCards';

export const OptionSumary = ({
  quotation,
  coverageCatalogs,
  coverageCatalogResumes,
  optionSelected,
  openDialog,
}: Props): JSX.Element => {
  const clonedQuotation = {
    ...quotation,
    packageOption:
      optionSelected !== 0 ? optionSelected : quotation.packageOption,
  };
  const unit = useMemo(() => defaultUnit(clonedQuotation), [clonedQuotation]);

  return (
    <>
      <Grid item xs={12}>
        <IndividualUnitResumeCard
          data-testid="individual-unit-resume-card"
          coverageCatalogs={coverageCatalogs}
          coverageCatalogResumes={coverageCatalogResumes}
          unit={unit}
          moneyType={quotation.quotationProfile.typeOfMoney}
          packageOption={optionSelected}
          quotation={clonedQuotation}
          openDialog={openDialog}
        />
      </Grid>
      <Grid item xs={12}>
        <ContractingInformationCard
          data-testid="contracting-information-card"
          quotation={quotation}
        />
      </Grid>
      <Grid item xs={12}>
        <VehicleInformationCard
          data-testid="vehicle-information-card"
          quotation={quotation}
        />
      </Grid>
    </>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  quotation: Quotation;
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
} => ({
  quotation: state.quotation.quotation,
  coverageCatalogs: state.coverageCatalog.coverageCatalogs,
  coverageCatalogResumes: state.coverageCatalog.coverageCatalogResumes,
});

const connector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
  optionSelected: number;
  openDialog: boolean;
}

export default connector(OptionSumary);
